module.exports = __webpack_public_path__ + "static/media/funaguchi.80f89564.png";